import { render, staticRenderFns } from "./WorkflowReport.vue?vue&type=template&id=c89a9faa"
import script from "./WorkflowReport.vue?vue&type=script&lang=js"
export * from "./WorkflowReport.vue?vue&type=script&lang=js"
import style0 from "./WorkflowReport.vue?vue&type=style&index=0&id=c89a9faa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports